<template>
  <div>
    <center class="card-header" style="margin-top: 30px;color: #90A4AE;">
      Incidencias por día / mes
    </center>
    <vue-apex-charts
      :key="key"
      type="bar"
      :options="options"
      :series="series"
      :height="'250px'"
    />
  </div>
</template>

<script>
import api from '@/services/api'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts,
  },
  props: {
    categories: {
      type: Array,
      required: false,
      default: null
    },
    seriesValue: {
      type: Array,
      required: false,
      default: null
    }
  },
  data: () => ({
    key: 0,
    options: {
      plotOptions: {
        bar: {
          barHeight: '80%',
          horizontal: false,
          dataLabels: {
            position: 'center', // top, center, bottom
          },
        }
      },
      colors: ['#90A4AE'],
      dataLabels: {
          enabled: true,
          textAnchor: 'start',
          formatter: function (val) {
              return '  '.concat(val)
          },
          offsetX: -10,
          offsetY: 0,
          style: {
              fontSize: '12px',
              colors: ["#FFF"]
          }
      },
      chart: {
        id: 'stats'
      },
      xaxis: {
        categories: []//[1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
      },
      title: {
        text: '',
        align: 'center',
        floating: true
      },
      subtitle: {
          text: '',
          align: 'center',
      },
    },
    series: [{
      name: 'errors',
      data: []//[30, 40, 45, 50, 49, 60, 70, 91]
    }]
  }),
  watch: {
    categories (newValue) {
      if (this.options.xaxis.categories !== newValue) {
        this.options.xaxis.categories = []
        this.options.xaxis.categories = newValue
      }
    },
    seriesValue (newValue) {
      if (this.series[0].data !== newValue) {
        this.key ++
        this.series[0].data = []
        this.series[0].data = newValue
      }
    }
  }
}
</script>

<style scoped>
  .itemNum {
    font-size: 40px;
    color: white;
  }
  .itemTitle {
    color: white;
  }
</style>